import React from 'react';
import { ThemeProvider as MaterialThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@mui/styles';

export * from '@mui/material/styles';
export { default as makeStyles } from '@mui/styles/makeStyles';
export { default as withStyles } from '@mui/styles/withStyles';

export function ThemeProvider({ theme, children }) {
  return React.createElement(
    MaterialThemeProvider,
    { theme },
    React.createElement(LegacyThemeProvider, { theme }, children),
  );
}
